function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDensityCompacti = function SvgDensityCompacti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M7.608 19a1.9 1.9 0 1 0-3.8 0 1.9 1.9 0 1 0 3.8 0m2.4.7h5.39a.7.7 0 1 0 0-1.4h-5.39a.7.7 0 1 0 0 1.4m-3.8-.7c0 .276-.23.5-.5.5a.5.5 0 1 1 0-1c.27 0 .5.224.5.5m-3.73-2.804h19a.7.7 0 1 0 0-1.4h-19c-.38 0-.7.314-.7.7s.32.7.7.7M7.608 12a1.9 1.9 0 1 0-3.8 0 1.9 1.9 0 1 0 3.8 0m2.4.7h3.63c.39 0 .71-.314.71-.7s-.32-.7-.71-.7h-3.63a.7.7 0 1 0 0 1.4m-3.8-.7c0 .276-.23.5-.5.5a.5.5 0 1 1 0-1c.27 0 .5.224.5.5m-3.73-2.889h19a.7.7 0 1 0 0-1.4h-19c-.38 0-.7.314-.7.7s.32.7.7.7M7.608 5a1.9 1.9 0 1 0-3.8 0 1.9 1.9 0 1 0 3.8 0m2.4.7h6.86a.7.7 0 1 0 0-1.4h-6.86a.7.7 0 1 0 0 1.4m-3.8-.7c0 .276-.23.5-.5.5a.5.5 0 1 1 0-1c.27 0 .5.224.5.5"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDensityCompacti);
export default ForwardRef;